import React, { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";
import "./SlideManager.css";

function SlideManager() {
  const [slides, setSlides] = useState([]);
  const [formData, setFormData] = useState({ subtitle: "", img_url: "" });
  const [subtitles, setSubtitles] = useState([]); // Alt başlıkları tutmak için state

  // Alt başlıkları Supabase'den çek
  useEffect(() => {
    const fetchSubtitles = async () => {
      const { data, error } = await supabase.from("headings").select("id, subtitle");

      if (error) {
        console.error("Alt başlıklar alınırken hata oluştu:", error);
      } else {
        setSubtitles(data || []); // Alt başlık verilerini kaydet
      }
    };

    fetchSubtitles();
  }, []);

  // Seçilen alt başlığa göre slaytları getir
  useEffect(() => {
    const fetchSlides = async () => {
      if (!formData.subtitle) return;

      // Alt başlığın ID'sini bul
      const selectedSubtitle = subtitles.find(
        (sub) => sub.subtitle === formData.subtitle
      );

      if (!selectedSubtitle) return;

      const { data, error } = await supabase
        .from("unit_slides")
        .select("*")
        .eq("unit_id", selectedSubtitle.id);

      if (error) {
        console.error("Slayt verileri alınırken hata oluştu:", error);
      } else {
        setSlides(data || []);
      }
    };

    fetchSlides();
  }, [formData.subtitle, subtitles]);

  // Slayt ekleme
  const addSlide = async () => {
    if (!formData.subtitle || !formData.img_url) {
      alert("Alt başlık ve resim URL'si gereklidir.");
      return;
    }

    // Alt başlığın ID'sini bul
    const selectedSubtitle = subtitles.find(
      (sub) => sub.subtitle === formData.subtitle
    );

    if (!selectedSubtitle) {
      alert("Geçerli bir alt başlık seçmelisiniz.");
      return;
    }

    const { error } = await supabase
      .from("unit_slides")
      .insert([{ unit_id: selectedSubtitle.id, img_url: formData.img_url }]);

    if (error) {
      console.error("Slayt eklenirken hata oluştu:", error);
    } else {
      setSlides([...slides, { unit_id: selectedSubtitle.id, img_url: formData.img_url }]);
      setFormData({ ...formData, img_url: "" });
    }
  };

  // Slayt silme
  const deleteSlide = async (id) => {
    const confirmed = window.confirm("Bu slaytı silmek istediğinize emin misiniz?");
    if (!confirmed) return;

    const { error } = await supabase.from("unit_slides").delete().eq("id", id);

    if (error) {
      console.error("Slayt silinirken hata oluştu:", error);
    } else {
      setSlides(slides.filter((slide) => slide.id !== id));
    }
  };

  return (
    <div className="slide-manager">
      <h3 className="slide-manager-title">Slayt Yönetimi</h3>
      <div className="add-slide-container">
        {/* Alt başlık dropdown */}
        <select
          className="slide-dropdown"
          value={formData.subtitle}
          onChange={(e) => setFormData({ ...formData, subtitle: e.target.value })}
        >
          <option value="">Alt Başlık Seçin</option>
          {subtitles.map((subtitle) => (
            <option key={subtitle.id} value={subtitle.subtitle}>
              {subtitle.subtitle}
            </option>
          ))}
        </select>

        {/* Resim URL alanı */}
        <input
          type="text"
          placeholder="Resim URL'si"
          value={formData.img_url}
          onChange={(e) => setFormData({ ...formData, img_url: e.target.value })}
          className="slide-input"
        />

        <button onClick={addSlide} className="slide-add-button">
          Ekle
        </button>
      </div>

      <div className="slide-list">
        {slides.length > 0 ? (
          slides.map((slide) => (
            <div key={slide.id} className="slide-item">
              <img src={slide.img_url} alt="Slayt" className="slide-image" />
              <button onClick={() => deleteSlide(slide.id)} className="slide-delete-button">
                Sil
              </button>
            </div>
          ))
        ) : (
          <p>Henüz slayt eklenmedi.</p>
        )}
      </div>
    </div>
  );
}

export default SlideManager;
